import React, { useContext } from 'react';

import { PageContext } from '../../../context';
import { LPText } from '../../../../styles';

import { ContentWrapper } from '../../../styles';

import ServiceDates from './ServiceDates';
import ServiceTimeSlots from './ServiceTimeSlots';
import BookingNav from '../../BookingNav';
import BrandFooter from '../../BrandFooter';

const BookingDate = () => {
  const context = useContext(PageContext);

  const {
    formData: { serviceDay, serviceInterval },
    queryData: {
      getVpn: {
        bookingLandingPage: { intervalListInstr },
      },
    },
  } = context;

  return (
    <>
      <ContentWrapper nopadding>
        <LPText padded w800>
          {intervalListInstr}
        </LPText>

        <ContentWrapper>
          <BookingNav />
          <ServiceDates />
          <ServiceTimeSlots />
        </ContentWrapper>
      </ContentWrapper>
      <BrandFooter disabled={!(serviceDay && serviceInterval)} />
    </>
  );
};

BookingDate.propTypes = {};

export default BookingDate;
